import {type ICartMetaData} from '../../../@type/woocommerce/cart-calculation';
import {Environment} from '../reducers/environmentReducer';
import {getLocaleText} from '../util/translation';

/**
 * Builds a renewing price string If a cart meta data includes subscription information.
 */
export function buildSubscriptionPriceMetaData(meta: ICartMetaData, short = false) {
	if (!meta.subscription) {
		return '';
	}

	/**
	 * Since the subscription period strings are being displayed in the modal but coming from third party plugin, we need to hardcode these strings' values
	 * so they can be captured by the gettext parser and be given translations.
	 */
	const subscriptionPeriodStrings: Record<string, string> = {
		day: getLocaleText('day'),
		week: getLocaleText('week'),
		month: getLocaleText('month'),
		year: getLocaleText('year'),
	};

	const subscriptionPeriod = subscriptionPeriodStrings[meta.subscription.period] ?? meta.subscription.period;

	if (Number.parseInt(String(meta.subscription.period_interval)) === 1) {
		return ` / ${subscriptionPeriod}`;
	}

	if (short) {
		return ` every ${meta.subscription.period_interval} ${subscriptionPeriod}s`;
	}

	return ` every ${meta.subscription.period_interval} ${subscriptionPeriod}s for ${meta.subscription.length} ${subscriptionPeriod}s`;
}

/**
 * Formats a date string into a subscription first renewal string.
 */
export function buildSubscriptionFirstRenewalString(meta: ICartMetaData) {
	if (!meta.subscription?.first_renewal) {
		return '';
	}

	const date = new Date(meta.subscription.first_renewal);
	const options: Intl.DateTimeFormatOptions = {
		year: 'numeric', // Ex: 2021
		month: 'long', // Ex: July
		day: 'numeric', // Ex: 12
	};

	return `${getLocaleText('First renewal')}: ${date.toLocaleString(Environment.language(), options)}`;
}
